import React, { useEffect, useState } from 'react'
import { Row, Col, Input, Select, Form, Button, Modal, message, Tooltip } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useRouteMatch, useHistory } from 'react-router-dom'
import axios from '../../../utils/AxiosUtil'
import '../../Content/content-common.less'
import './add-user.less'
import UserCheckMenu from './userCheckMenu'
import { getCheckedMenuId } from './userHelper'
import { axiosPostAndHint } from '../../../components/reqAndHint'
import AsyncTree from './AsyncTree'
import { useSelector } from 'react-redux'
message.config({ top: 100 });


const { Option } = Select;

export default function UpdateUser(props) {
    let history = useHistory();
    const langValue = useSelector(state => state.langList.value)
    let { url } = useRouteMatch();
    let uid = url.substr(url.lastIndexOf('/') + 1);//从地址栏中截取uid


    const [form] = Form.useForm();
    const [stateRoleId, setStateRoleId] = useState(null);
    const [checkedAreas, setCheckedAreas] = useState([]);//数组类型
    /**
     * 初始查询方式byUser，根据uid回显。若重选职称，根据职称回显
     */
    const [queryMenuType, setQueryMenuType] = useState('byUser');


    useEffect(async () => {
        try {
            let { data } = await axios.post('/fund/user/queryById', { uid });
            // console.log('result:', data);
            if (data) {
                // console.log("查询用户信息成功:", data.data);
                let { uname, userStatus, account, roleId, billSpot } = data.data;
                form.setFieldsValue({ "uname": uname, 'account': account, userStatus: userStatus, roleId: roleId, billSpot: '001' });
                setStateRoleId(roleId);
            } else {
                // console.log('else:|' + data.code + '|uinfo:', data.data);
            }
        } catch (error) {
            // console.log("查询用户信息失败:", error);
        }
    }, [])


    function resetFormFields() {
        // console.log('form reset fields*');
        form.resetFields();
    }

    function onFinishFailed({ values, errorFields, outOfDate }) {
        // console.log("updateUser form onFinishFailed:", values, errorFields, outOfDate);
        Modal.warn({ title: '用户信息验证未通过，请回顶部修改' });
    }

    function onFinish(values) {
        // console.log("updateUser form onFinish:", values);
        let menuIds = getCheckedMenuId();
        // console.log("menuIds:", menuIds);
        if (!checkedAreas ?.length) {
            Modal.warn({ title: '请先关联地区' });
            return;
        }

        if (!menuIds ?.length) {
            Modal.warn({ title: '请先设定权限' });
            return;
        }
        //因暂用不到开票点（billSpot）字段，暂用默认值‘001’代替。后续若该功能确认不需要再行删除250512
        axiosPostAndHint('/user/update',
            { uid, menuIds, AIds: checkedAreas, ...values, billSpot: '001' },
            () => {
                resetFormFields();
                history.push(`/view/user/list`);
            }
        );
    }

    function onValChange(val, allVals) {
        // console.log("onvalChange:", val, allVals);
        let key = Object.keys(val)[0];
        // console.log("onValChange key:", key);
        if (key == "roleId") {
            setStateRoleId(val['roleId']);
            setQueryMenuType('byRole');
            message.destroy();
            message.info("已同步切换权限，请按需确认")
        }
    }

    let submitBtnStyle = {

        'height': '60px',
        'backgroundColor': '#526be8',
        'borderRadius': '4px',
    }



    return (
        <div className="add-user">
            <Form
                name="add-user"
                form={form}
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
                onValuesChange={onValChange}
            >
                <div className='user-info'>
                    <h1 className="info-title">{langValue == 0 ? '用户信息 User Info' : (langValue == 1 ? '用户信息' : 'User Info')}</h1>
                    <div className='info-content'>
                        <Row gutter={[2, { xs: 1, sm: 2, md: 3, lg: 4 }]} sytle={{ 'width': '60%' }}>
                            <Col className="gutter-row" span={6}>

                                <div className="input-wrapper">
                                    <label htmlFor="account">{langValue == 0 ? '账号Account No.' : (langValue == 1 ? '账号' : 'Account No.')}：</label>
                                    <Form.Item
                                        name="account"
                                        rules={[{ required: true, message: '请输入用户账号' }]}
                                    >
                                        <Input id="account" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </Form.Item>
                                </div>

                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="input-wrapper">
                                    <label htmlFor="uname">{langValue == 0 ? '名称Username' : (langValue == 1 ? '名称' : 'Username')}：</label>
                                    <Form.Item
                                        name="uname"
                                        rules={[{ required: true, message: '请输入用户名称' }]}
                                    >
                                        <Input id="uname" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </Form.Item>
                                </div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="input-wrapper">
                                    <label htmlFor="roleId">{langValue == 0 ? '职称Job Title' : (langValue == 1 ? '职称' : 'Job Title')}：</label>
                                    {/* 换行 */}
                                    <div></div>
                                    <Form.Item
                                        name="roleId"
                                        rules={[{ required: true, message: '请选择职称' }]}
                                    >
                                        <Select placeholder={langValue == 0 ? '请选择Please select' : (langValue == 1 ? '请选择' : 'Please select')} style={{ width: 200 }} >
                                            <Option value="4" key="4">{langValue == 0 ? '地区财务窗口Regional financial window' : (langValue == 1 ? '地区财务窗口' : 'Regional financial window')}</Option>
                                            <Option value="3" key="3">{langValue == 0 ? '一般财务同仁General financial colleagues' : (langValue == 1 ? '一般财务同仁' : 'General financial colleagues')}</Option>
                                            <Option value="2" key="2">{langValue == 0 ? '财务管理员Financial administrator' : (langValue == 1 ? '财务管理员' : 'Financial administrator')}</Option>
                                        </Select>
                                    </Form.Item>
                                </div>
                            </Col>
                            {/* <Col className="gutter-row" span={6}>
                                {(stateRoleId == '2' || stateRoleId == '3') ?
                                    (

                                        <div className="input-wrapper" >
                                            <label htmlFor="bill-site">{langValue == 0 ? '关联开票点Related Ticket points' : (langValue == 1 ? '关联开票点' : 'Related Ticket points')}：</label>
                                            <Form.Item name="billSpot"
                                                rules={[{ required: true, message: '请输入开票点' }]}>
                                                <Input id="bill-site" className="u-input" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} />
                                            </Form.Item>
                                        </div>

                                    ) : null}
                            </Col> */}
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    name="password"
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="password">密码(不更新则不填):</label>
                                        <Input.Password
                                            placeholder={langValue == 0 ? '请输入密码Enter Password' : (langValue == 1 ? '请输入密码' : 'Enter Password')} id="password"
                                            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                            style={{ paddingLeft: 10 }}
                                        />
                                    </div>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="input-wrapper">
                                    <label htmlFor="userStatus">{langValue == 0 ? '状态Status' : (langValue == 1 ? '状态' : 'Status')}</label>
                                    {/* 换行 */}
                                    <div></div>
                                    <Form.Item
                                        name="userStatus"
                                    >
                                        <Select style={{ width: 120 }} >
                                            <Option value="on" key="on">{langValue == 0 ? '启用Active' : (langValue == 1 ? '启用' : 'Active')}</Option>
                                            <Option value="off" key="off">{langValue == 0 ? '停用Inactive' : (langValue == 1 ? '停用' : 'Inactive')}</Option>
                                        </Select>
                                    </Form.Item>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className='user-info'>
                    <h1 className="info-title">{langValue == 0 ? '关联地区 Related regions' : (langValue == 1 ? '关联地区' : 'Related regions')}</h1>
                    <div className='info-content'>
                        {/* ***defaultCheckedKeys */}
                        <AsyncTree uid={uid}
                            handleCheck={(checkedKeys, event) => {
                                console.log("checkedAreas:", checkedAreas);
                                setCheckedAreas(checkedKeys);
                            }}
                            setDefaultCheckedArea={
                                (defaultCheckedKeys) => {
                                    // console.log("**defaultCheckedKeys:", defaultCheckedKeys);
                                    setCheckedAreas([...defaultCheckedKeys]);
                                }
                            }
                        />
                    </div>

                    <div style={{ paddingBottom: 50, marginLeft: 24 }}>
                        <h2>{langValue == 0 ? '权限设定 Permission settings' : (langValue == 1 ? '权限设定' : 'Permission settings')}：</h2>
                        {checkedAreas ?.map((area, i) => {
                            return <Tooltip key={i} title={area ?.split('-')[0]}>
                                <Button style={{ margin: 10 }}>{area ?.split('-')[0]}</Button>
                            </Tooltip>
                        })}
                    </div>

                </div>
                <div className='user-info'>
                    <h1 className="info-title">{langValue == 0 ? '权限设定 Permission settings' : (langValue == 1 ? '权限设定' : 'Permission settings')}</h1>
                    <div className='info-content'>
                        <UserCheckMenu uid={uid} queryType={queryMenuType} roleId={stateRoleId} />
                    </div>
                </div>
                <div style={{ marginLeft: 24, paddingBottom: 24 }}>
                    <Button type="primary" htmlType="submit" style={submitBtnStyle}>
                        {langValue == 0 ? '确定更新Confirm update' : (langValue == 1 ? '确定更新' : 'Confirm update')}
                    </Button>
                </div>
            </Form>
        </div>
    )
}
